
import { Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InvalidField } from '../../functions/forms.helpers';

export interface MceSaveCancelButtonConfig {
  show: boolean;
  enable: boolean;
}

export interface MceSaveCancelConfig {
  save?: MceSaveCancelButtonConfig;
  cancel?: MceSaveCancelButtonConfig;
  back?: MceSaveCancelButtonConfig;
  ok?: MceSaveCancelButtonConfig;
  invalidFields?: InvalidField[];
}

export interface MceSaveCancelEvent {
  type: 'save' | 'cancel' | 'back' | 'ok';
}


@Component({
    selector: 'mce-save-cancel',
  imports: [MatToolbarModule, MatIconModule, MatButtonModule, MatTooltipModule],
    templateUrl: './mce-save-cancel.component.html',
})
export class MceSaveCancelComponent {
  readonly config = input.required<MceSaveCancelConfig>();
  readonly action = output<MceSaveCancelEvent>();

  readonly invalidFieldsTooltip = computed(() => {
    const fields = this.config().invalidFields ?? [];
    const fieldNames = Array.from(
      new Set(fields.map(field => {
        const normalizedPath = field.path.replace(/^root\.?/, '');
        return normalizedPath === '' ? 'root' : normalizedPath;
      }))
    );

    return `Invalid fields: ${fieldNames.join(', ')}`;
  });

  onAction(type: MceSaveCancelEvent['type']): void {
    this.action.emit({ type });
  }

}
